import { render } from "./PurchaseHistoryView.vue?vue&type=template&id=4e37ad0e"
import script from "./PurchaseHistoryView.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryView.vue?vue&type=script&lang=js"

import "./PurchaseHistoryView.vue?vue&type=style&index=0&id=4e37ad0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__